export const ADMINISTRATIVE_BUDGET_TYPES = {
  PIX: 'pix',
  BOLETO: 'boleto',
};

export const ADMINISTRATIVE_BUDGET_ITEM_TYPE = 'administrative';
